module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('h1', {
    staticClass: "h1"
  }, [_c('span', {
    attrs: {
      "aria-label": "page vi",
      "epub:type": "pagebreak",
      "id": "page_vi",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page 1",
      "epub:type": "pagebreak",
      "id": "page_1",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "b1"
  }, [_vm._v("Chapter")]), _vm._v(" "), _c('span', {
    staticClass: "heading_break1"
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("M")]), _vm._v("y name is Mindy Kim. I am eight years old, and I’m now in third grade!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So far, third grade isn’t as easy as second grade. There is a lot more homework, and the math is harder. But there are lots of fun new things too! We have new responsibilities, like helping our teacher, Mr. Brady, around the classroom. We also have a classroom guinea pig, Mr. Snuffles!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sit next to Mr. Snuffles in class. He’s a little smelly, but he’s so cute that I don’t mind. Mr. Snuffles has brown-and-white fur and large black eyes. Occasionally, he makes funny little squeaking "), _c('span', {
    attrs: {
      "aria-label": "page 2",
      "epub:type": "pagebreak",
      "id": "page_2",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("sounds that make me smile. On special occasions, like someone’s birthday, Mr. Brady puts a bow tie around his neck!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Today Mr. Brady announced that we’re having class-president elections.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know it’s October, and everyone’s probably busy preparing for Halloween this weekend, but it’s been two weeks since our old class president, Dill, moved away,” he explained. “So we need someone to replace him. And what could be a better time to have a class election than next week, when the adults in our country will vote for a new president of the United States?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dill was really nice, and he was such a good class president, too! He was one of the first friends I made when I moved to Florida last year. I was really sad when he moved away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Priscilla raised her hand. She’s the girl who sits at the front of the class and always asks questions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, Priscilla?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do we have to do during the class-president election?” she asked.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16f56fb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781534440180/xhtml/ch01.vue
// module id = 63
// module chunks = 0